
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountriesForBookingsDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Country"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicData"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"key"},"name":{"kind":"Name","value":"iso_alpha2_code"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"iso_alpha2_code"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountriesWithSubdivisionsForDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Country"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownData"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"children"},"name":{"kind":"Name","value":"country_subdivisions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownData"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountriesWithSubdivisionsForBookingsDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Country"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountriesForBookingsDropdown"},"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"children"},"name":{"kind":"Name","value":"country_subdivisions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySubdivisionsForBookingsDropdown"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountryFullDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Country"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DropdownData"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iso_alpha2_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iso_alpha3_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iso_numeric_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handle_geo_restrictions_on_subdivision_level"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":762}};
    doc.loc.source = {"body":"#import \"../interface.graphql\"\n#import \"../countrySubdivision/fragment.graphql\"\n\nfragment CountriesForBookingsDropdown on Country {\n    ...BasicData\n    key : iso_alpha2_code\n    value : iso_alpha2_code\n    text : name\n}\n\nfragment CountriesWithSubdivisionsForDropdown on Country {\n    ...DropdownData\n    children: country_subdivisions {\n        ...DropdownData\n    }\n}\n\nfragment CountriesWithSubdivisionsForBookingsDropdown on Country {\n    ...CountriesForBookingsDropdown\n    children: country_subdivisions {\n        ...CountrySubdivisionsForBookingsDropdown\n    }\n}\n\nfragment CountryFullDataFragment on Country {\n    ...DropdownData\n    full_name\n    iso_alpha2_code\n    iso_alpha3_code\n    iso_numeric_code\n    handle_geo_restrictions_on_subdivision_level\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../interface.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../countrySubdivision/fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CountriesForBookingsDropdown"] = oneQuery(doc, "CountriesForBookingsDropdown");
        
        module.exports["CountriesWithSubdivisionsForDropdown"] = oneQuery(doc, "CountriesWithSubdivisionsForDropdown");
        
        module.exports["CountriesWithSubdivisionsForBookingsDropdown"] = oneQuery(doc, "CountriesWithSubdivisionsForBookingsDropdown");
        
        module.exports["CountryFullDataFragment"] = oneQuery(doc, "CountryFullDataFragment");
        
